<template>
  <div>
    <h4 style="color: #26336A; padding-top: 4rem;">매칭 프로세스</h4>
    <div style="display: flex; justify-content: center;">
      <section class="flex statusMatchingRow">
        <div
          class="statusMatchingItem"
          v-for="(item, index) in statusMatchingItems"
          :key="index"
          :style="{ backgroundColor: item.bgColor }"
        >
          <figure class="image">
            <img :src="item.img" :alt="item.title" />
          </figure>
          <div class="itemText">
            <div style="display: flex; justify-content: center;">
              <div class="itemTextIcon">
                <figure>
                  <img :src="item.icon" :alt="item.title" />
                </figure>
                <h6>프로필 작성</h6>
              </div>
            </div>
            <h6 class="itemTextDesc">
              다른 기업들에게 보여질 소중한 기업정보를 입력해주세요.
            </h6>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "MatchingProcessItems",
  data() {
    return {
      statusMatchingItems: [
        {
          id: 1,
          title: "총 신청 수",
          number: "1423 건",
          img: "/images/myPage/matching1.svg",
          icon: "/images/myPage/docs.svg",
          bgColor: "#FFFDEE",
          textColor: "#26336A",
        },
        {
          id: 1,
          title: "매칭 대기",
          number: "123 건",
          img: "/images/myPage/matching2.svg",
          icon: "/images/myPage/search.svg",
          bgColor: "#FFFCDF",
          textColor: "#3F7416",
        },
        {
          id: 1,
          title: "매칭 완료",
          number: "1423 건",
          img: "/images/myPage/matching3.svg",
          icon: "/images/myPage/chat.svg",
          textColor: "#2B939A",
          bgColor: "#FFFACD",
        },
        {
          id: 1,
          title: "매칭 거절",
          number: "1423 건",
          img: "/images/myPage/matching4.svg",
          icon: "/images/myPage/hand.svg",
          textColor: "#BD4444",
          bgColor: "#FFF499",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped></style>
